"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _Theme = require("material-ui-shell/lib/providers/Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Scrollbar = function Scrollbar(props) {
  var _props$forwardedRef = props.forwardedRef,
      forwardedRef = _props$forwardedRef === void 0 ? function () {} : _props$forwardedRef,
      rest = _objectWithoutPropertiesLoose(props, ["forwardedRef"]);

  var _useAppTheme = (0, _Theme.useTheme)(),
      isRTL = _useAppTheme.isRTL;

  var refSetter = (0, _react.useCallback)(function (scrollbarsRef) {
    if (scrollbarsRef) {
      forwardedRef(scrollbarsRef.view);
    } else {
      forwardedRef(null);
    }
  }, [forwardedRef]);
  return (
    /*#__PURE__*/

    /* native scrollbars needs to be conditionally turned off in rtl */
    _react.default.createElement(_reactCustomScrollbars.Scrollbars, _extends({
      hideTracksWhenNotNeeded: true,
      ref: refSetter,
      renderView: function renderView(props) {
        return isRTL ? /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
          style: _extends(_extends({}, props.style), {}, {
            marginLeft: props.style.marginRight,
            marginRight: 0
          })
        })) : /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
          style: _extends({}, props.style)
        }));
      }
    }, rest))
  );
};

var _default = Scrollbar;
exports.default = _default;
module.exports = exports.default;